export type HouseholdIncome = number | null | undefined | string;

export type DebtAmount = number | null | undefined | string;

export type DebtTypes =
  | 'CREDIT_CARD_DEBT'
  | 'PAY_DAY_PERSONAL_LOANS_DEBT'
  | 'STUDENT_LOAN_DEBT'
  | 'MEDICAL_DEBT'
  | 'LINES_OF_CREDIT'
  | 'OTHER_LOANS';

export type Goal =
  | 'REDUCE_MTHLY_PAYMTS'
  | 'GET_OUT_DEBT_FASTER'
  | 'IMPROVE_CREDIT_SCORE'
  | '';

export type PaymentStatus =
  | 'CURRENT_STRUGGLING'
  | 'BEHIND_LESS_6_MTHS'
  | 'BEHIND_MORE_6_MTHS'
  | '';

export type DebtCause =
  | 'POOR_MONEY_MGMT'
  | 'REDUCED_INCOME'
  | 'UNEMPLOYED'
  | 'FAMILY_DEATH'
  | 'DIVORCE_SEPARATION'
  | 'MEDICAL'
  | 'OTHER'
  | '';

export type EmploymentStatus =
  | 'FULL_TIME'
  | 'PART_TIME'
  | 'UNEMPLOYED'
  | 'RETIRED'
  | '';

export type LeadType = 'Debt Settlement' | 'Debt Management';

export type IncomeConsistency =
  | 'VERY_CONSISTENT'
  | 'CONSISTENT'
  | 'NOT_CONSISTENT'
  | '';

export type CreditScore =
  | 'EXCELLENT'
  | 'VERY_GOOD'
  | 'GOOD'
  | 'FAIR'
  | 'POOR'
  | 'NOT_SURE'
  | '';

export enum EngagementActionEnum {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  EMPTY = '',
}

export enum CreditImportanceOptionsEnum {
  IMPT = 'IMPT',
  NOT_IMPT = 'NOT_IMPT',
  EMPTY = '',
}

export enum LoanOptionsEnum {
  YES = 'YES',
  NO = 'NO',
  EMPTY = '',
}

export enum CreditScoreImportanceOptionsEnum {
  YES = 'YES',
  NO = 'NO',
  MAYBE = 'MAYBE',
  EMPTY = '',
}

export enum LivingStatusOptionsEnum {
  OWN = 'OWN',
  RENT = 'RENT',
  OTHER = 'OTHER',
  EMPTY = '',
}

export type CreditScoreImportance =
  | keyof typeof CreditScoreImportanceOptionsEnum
  | '';

export type LivingStatus = keyof typeof LivingStatusOptionsEnum | '';

export type CreditImportance = keyof typeof CreditImportanceOptionsEnum | '';

export type LoanOptions = keyof typeof LoanOptionsEnum | '';

export enum QualificationStatusEnum {
  SINGLE_QUALIFIED = 'single_qualified',
  MULTIPLE_QUALIFIED = 'multiple_qualified',
  UNQUALIFIED = 'unqualified',
}

export type QualificationStatus =
  (typeof QualificationStatusEnum)[keyof typeof QualificationStatusEnum];

export type FutureLoanPlans = {
  mortgage_in_2_years?: boolean;
  auto_in_2_years?: boolean;
  none?: boolean;
};

export const STATUS_OPTIONS = {
  PENDING: 'pending',
  READY: 'ready_for_evaluation',
  COMPLETE: 'evaluation_complete',
  READY_FOR_SUBMISSION: 'ready_for_submission',
  PENDING_ONBOARDING: 'pending_onboarding',
  USER_ABANDONED: 'user_abandoned',
};

export type StatusOption = (typeof STATUS_OPTIONS)[keyof typeof STATUS_OPTIONS];

export interface AppConfig {
  maximumDebtAmount: number;
  maximumIncomeAmount: number;
}

export interface CounselorQuestions {
  hiddenFields: HiddenFields;
  pii: PII;
  contactInfo: ContactInfo;
  debtInfo: DebtInfo;
  employmentInfo: EmploymentInfo;
  creditInfo: CreditInfo;
  propertyInfo: PropertyInfo;
  resultOptions: ResultOptions;
}

export interface HiddenFields {
  state: string;
}

export interface PII {
  firstName: string;
  lastName: string;
  zip: string;
  state: string;
  debtAmount: DebtAmount;
  goal: Goal;
}

export interface ContactInfo {
  email: string;
  phone: string;
}

export interface DebtInfo {
  debtTypes: DebtTypes[];
  paymentStatus: PaymentStatus;
  debtCause: DebtCause;
}

export interface EmploymentInfo {
  employmentStatus: EmploymentStatus;
  householdIncome: HouseholdIncome;
  incomeConsistency: IncomeConsistency;
}

export interface CreditInfo {
  creditScore: CreditScore;
  creditScoreImportance: CreditScoreImportance;
}

export interface PropertyInfo {
  livingStatus: LivingStatus;
  futureLoanPlans: FutureLoanPlans;
}

export interface ResultOptions {
  leadType: string;
}

export interface DigitalEnrollmentPrograms {
  [program: string]: boolean;
}

export interface AppConfig {
  maximumDebtAmount: number;
  maximumIncomeAmount: number;
}
